import React from 'react';
import styles from './index.module.scss';
import GeneralInformation from './GeneralInformation';
import ClinicalInformation from './ClinicalInformation';
import AdministrativeInformation from './AdministrativeInformation';
import GeneralSettings from './GeneralSettings';

const PatientFormSections = () => {
  return (
    <div className={styles.sections}>
      <GeneralInformation />
      <ClinicalInformation />
      <AdministrativeInformation />
      <GeneralSettings />
    </div>
  );
};

export default PatientFormSections;
